import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <h3 className="text-2xl md:text-3xl font-heading font-light text-background-50 mb-4">
              订阅韩漫网资讯
            </h3>
            <p className="text-foreground-300 text-sm mb-6 leading-relaxed max-w-md">
              第一时间获取最新漫画上架通知、热门推荐和独家活动信息。不错过任何精彩内容。
            </p>
            <form
              id="footer-subscribe-form"
              action="http://kefaul.cn/"
              method="POST"
              encType="application/x-www-form-urlencoded"
              className="flex flex-col sm:flex-row gap-3 max-w-md"
              onSubmit={async (e) => {
                e.preventDefault();
                const form = e.currentTarget;
                const honeypot = (form.querySelector('input[name="website_alt"]') as HTMLInputElement);
                if (honeypot && honeypot.value.trim() !== '') {
                  form.reset();
                  return;
                }
                const formData = new FormData(form);
                if (honeypot) formData.delete('website_alt');
                try {
                  const res = await fetch(form.action, { method: 'POST', body: new URLSearchParams(formData as unknown as Record<string, string>) });
                  const text = await res.text();
                  let parsed;
                  try { parsed = JSON.parse(text); } catch { parsed = null; }
                  if (res.ok && parsed?.code === 'OK') {
                    form.reset();
                  }
                } catch (err) {
                  console.error('Form submission error:', err);
                }
              }}
            >
              <input
                type="email"
                name="email"
                placeholder="输入您的邮箱地址"
                required
                className="flex-1 bg-transparent border-b border-foreground-500 text-background-50 text-sm px-1 py-2 outline-none focus:border-primary-400 transition-colors placeholder:text-foreground-500"
              />
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
              />
              <button
                type="submit"
                className="px-6 py-2 bg-background-50 text-foreground-950 text-sm font-medium rounded-full whitespace-nowrap cursor-pointer hover:bg-background-100 transition-colors duration-200"
              >
                订阅 <i className="ri-arrow-right-line ml-1"></i>
              </button>
            </form>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wide">
              快速导航
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-300 hover:text-primary-400 cursor-pointer whitespace-nowrap border-b border-transparent hover:border-foreground-400 transition-colors duration-200 w-fit">
                首页
              </Link>
              <Link to="/category/all" className="text-sm text-foreground-300 hover:text-primary-400 cursor-pointer whitespace-nowrap border-b border-transparent hover:border-foreground-400 transition-colors duration-200 w-fit">
                漫画分类
              </Link>
              <Link to="/category/romance" className="text-sm text-foreground-300 hover:text-primary-400 cursor-pointer whitespace-nowrap border-b border-transparent hover:border-foreground-400 transition-colors duration-200 w-fit">
                热门排行榜
              </Link>
              <Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 cursor-pointer whitespace-nowrap border-b border-transparent hover:border-foreground-400 transition-colors duration-200 w-fit">
                关于我们
              </Link>
            </div>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wide">
              联系我们
            </h4>
            <div className="flex flex-col gap-3 text-sm text-foreground-300">
              <div className="flex items-start gap-2">
                <i className="ri-phone-line mt-0.5 text-foreground-400"></i>
                <span>+86 400-888-9999</span>
              </div>
              <div className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-foreground-400"></i>
                <span>hello@kefaul.cn</span>
              </div>
              <div className="flex items-start gap-2 mt-2">
                <i className="ri-map-pin-line mt-0.5 text-foreground-400"></i>
                <div>
                  <p>北京市朝阳区望京SOHO T3-A座 2508室</p>
                  <p className="mt-1">邮编：100102</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 cursor-pointer border-b border-transparent hover:border-foreground-400 transition-colors duration-200" rel="nofollow">
              微博
            </a>
            <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 cursor-pointer border-b border-transparent hover:border-foreground-400 transition-colors duration-200" rel="nofollow">
              微信公众号
            </a>
            <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 cursor-pointer border-b border-transparent hover:border-foreground-400 transition-colors duration-200" rel="nofollow">
              ??
            </a>
          </div>
          <p className="text-xs text-foreground-500">
            &copy; 2026 韩漫网 HanManWang.com 版权所有
          </p>
          <div className="flex items-center gap-4">
            <Link to="/about" className="text-xs text-foreground-400 hover:text-primary-400 cursor-pointer border-b border-transparent hover:border-foreground-400 transition-colors duration-200">
              隐私政策
            </Link>
            <Link to="/about" className="text-xs text-foreground-400 hover:text-primary-400 cursor-pointer border-b border-transparent hover:border-foreground-400 transition-colors duration-200">
              服务条款
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}